<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font"
            >Middleman管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="item_font">客服反馈</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <el-form
        ref="form"
        label-width="60px"
        :model="form"
        @submit.native.prevent
        class="headerForm"
      >
        <el-form-item label-width="140px" class="header-item reset-form">
          <el-select
            placeholder="选择科室"
            size="small"
            v-model="form.depType"
            @change="selectOffice"
            clearable
          >
            <el-option
              :label="item.name"
              :value="item.id"
              :key="item.id"
              v-for="item in officeList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="140px" class="reset-form">
          <el-select
            placeholder="是否处理"
            size="small"
            @change="changeStatus"
            clearable
            v-model="form.status"
          >
            <el-option label="待" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.time"
            type="datetimerange"
            align="right"
            size="small"
            @change="selectTime"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label-width="auto" style="margin-left: auto">
          <el-input
            placeholder="关键字/搜索句/访客昵称/站点"
            size="small"
            v-model="form.searchValue"
            clearable
            style="margin: 6px 0; min-width: 300px"
          >
            <template slot="append">搜索</template>
          </el-input>
        </el-form-item> -->
      </el-form>
      <div class="infoList" v-loading="isLoading">
        <div
          class="infoList-item"
          v-for="(item, index) in diaList"
          :key="index"
        >
          <div class="infoList-header">
            <div>科室：{{ item.depType }}</div>
            <div>反馈人： {{ item.csName }}</div>
            <div>提交：{{ item.createTime }}</div>
            <el-button
              plain
              size="mini"
              style="margin-left: auto; margin-right: 30px"
              @click="getAllDia(item.sid, item.jsonObjects)"
              >完整会话</el-button
            >
            <div class="infoList-header-state" v-if="item.status === 0">
              <i class="el-icon-error" @click="handleStatus(2, item)"></i>
              <i class="el-icon-success" @click="handleStatus(1, item)"></i>
            </div>

            <span
              v-if="item.status !== 0"
              :style="{
                color: item.status === 1 ? '#07c160' : '#de4f4f',
              }"
              >{{ item.status === 1 ? "已处理" : "未处理" }}</span
            >
          </div>
          <div class="infoList-content">
            <div style="border-bottom: 1px solid #999">
              <div
                v-for="(info_item, info_index) in item.jsonObjects"
                :key="info_index"
                style="line-height: 20px; margin-bottom: 10px"
              >
                {{ info_item.createTime }}
                <span v-if="info_item.origin === 0" style="color: #009abc"
                  >访客：{{ info_item.message }}</span
                >
                <span v-if="info_item.origin === 2" style="color: #fa8072"
                  >系统：{{ info_item.message }}</span
                >
                <span
                  v-if="info_item.origin === 1 || info_item.origin === 3 || info_item.origin === 6"
                  style="color: #9b2a88"
                  >客服：{{ info_item.message }}</span
                >
              </div>
            </div>
            <div class="infoList-content-footer">
              备注：<span style="color: #333">{{ item.remark }}</span>
            </div>
          </div>
        </div>
        <el-empty description="暂无数据" v-if="diaList.length == 0"></el-empty>
        <el-pagination
          style="text-align: center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="inforTotal"
        >
        </el-pagination>
      </div>
    </el-main>
    <!--反馈提示弹窗  -->
    <el-dialog
      title="反馈提示"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="wrongMessageEditDto.dealRemark = ''"
      class="dialogFontSize"
    >
      <template slot="title">
        <span class="el-dialog__title">处理说明</span>
      </template>
      <el-input
        type="textarea"
        :autosize="{ minRows: 3 }"
        placeholder="请输入处理说明"
        v-model="wrongMessageEditDto.dealRemark"
        @close="wrongMessageEditDto.status = 0"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button size="mini" type="primary" @click="handleTrue"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 完成对话弹窗 -->
    <el-dialog
      :visible.sync="dialogAllDia"
      width="50%"
      :close-on-click-modal="false"
      :lock-scroll="false"
      class="dialogAllDia"
      @close="this.allDiaData = null"
    >
      <template slot="title">
        <span class="el-dialog__title">完整会话</span>
      </template>
      <div
        v-for="(item, index) in allDiaData"
        :key="index"
        style="line-height: 30px"
        class="dialogFontSize"
        :style="{ 'background-color': item.flag ? '#DDD' : '' }"
      >
        {{ item.createTime }}{{ item.flag }}
        <span
          v-if="
            item.origin !== 0 &&
            item.origin !== 1 &&
            item.origin !== 2 &&
            item.origin !== 3 &&
            item.origin !== 6
          "
          style="color: #000"
          >[提示]-{{ item.content }}</span
        >

        <span v-if="item.origin === 0" style="color: #009abc"
          >访客：{{ item.content }}</span
        >
        <span v-if="item.origin === 2" style="color: #fa8072"
          >系统：{{ item.content }}</span
        >
        <span
          v-if="item.origin === 1 || item.origin === 3 || item.origin === 6"
          style="color: #9b2a88"
          >客服：{{ item.content }}</span
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      // 头部展示数据
      form: {
        depType: "",
        status: "",
        searchValue: "",
        time: [],
      },
      //
      infoList: [],
      officeList: [],
      // 展示的会话列表
      diaList: [1],
      dialogVisible: false,
      // 完整会话弹窗
      dialogAllDia: false,
      allDiaData: [],
      // 处理说明
      wrongMessageEditDto: {
        dealRemark: "",
        status: 0,
        csId: this.util.getLocalAccount().id,
        sid: "",
      },
      // 条件筛选
      wrongMessageSearchDto: {
        depType: "",
        status: "",
        startTime: "",
        endTime: "",
      },
      currentPage: 1,
      pageSize: 10,
      inforTotal: null,
      isLoading: false,
    };
  },
  mounted() {
    this.getOfficeList();
    this.getDiaLists();
    this.getAllDiaNum();
  },
  watch: {
    // diaList: {
    //   handler(newVal, oldVal) {
    //     console.log("newVal:", newVal);
    //     console.log("oldVal:", oldVal);
    //     console.log(oldVal === newVal);
    //     if (newVal !== oldVal) {
    //       this.diaList = newVal;
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDiaLists();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDiaLists();
      this.util.animation(this.$parent.$el, 0);
    },

    // 点击确认
    handleTrue() {
      if (this.wrongMessageEditDto.dealRemark === "") {
        this.$message.error("处理说明不能为空");
      } else {
        this.changeState();
      }
    },
    // 发送请求 改变状态
    async changeState() {
      var api = "/manager/wrongMessageDeal/editStatus";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.wrongMessageEditDto,
      });
      console.log(response);
      if (response.resultCode === "10000") {
        this.$message.success("操作成功");
        this.dialogVisible = false;
        this.getDiaLists();
      } else {
        this.$message.error(response.desc);
      }
    },

    handleStatus(source, item) {
      this.dialogVisible = true;
      this.wrongMessageEditDto.sid = item.sid;
      if (source === 1) {
        this.wrongMessageEditDto.status = 1;
      } else {
        this.wrongMessageEditDto.status = 2;
      }
    },
    // 科室列表
    async getOfficeList() {
      var api = "/manager/departmentType/getDepTypeList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log(response);
      if (response.resultCode === "10000") {
        this.officeList = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    // 获取信息列表
    async getDiaLists() {
      this.isLoading = true;
      var api = "/manager/wrongMessageDeal/selectList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.currentPage,
          size: this.pageSize,
        },
      });

      console.log("response--------", response);
      if (response.resultCode === "10000") {
        this.diaList = response.data;
        this.getItemInfo();
        this.isLoading = false;
      } else {
        this.$message.error(response.desc);
      }
    },
    // 获取信息  并进行二次处理
    getItemInfo() {
      console.log("diaList:", this.diaList);
      this.infoSort(this.diaList);
      this.diaList.forEach((item, index) => {
        var office_index = Number(this.diaList[index].depType) - 1;
        this.diaList[index].depType = this.officeList[office_index].name;
        // this.getDiaInfnText(item);
      });
    },
    // 筛选科室
    selectOffice(value) {
      if (value === "") {
        this.wrongMessageSearchDto.depType = "";
      } else {
        this.wrongMessageSearchDto.depType = Number(this.form.depType);
      }
      this.selectDate();
    },
    // 获取数量
    async getAllDiaNum() {
      var api = "/manager/wrongMessageDeal/getCount";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode === "10000") {
        console.log("response.length---------:", response.data);
        this.inforTotal = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    infoSort(data) {
      data.sort((a, b) => {
        return new Date(b.createTime) - new Date(a.createTime);
      });
    },
    async getAllDia(sid, remarks) {
      console.log("asd:", sid);
      this.dialogAllDia = true;
      var api = "/manager/wrongMessageDeal/selectChatMessageBysid?sid=" + sid;
      const response = await this.util.postRequest({
        url: api,
      });
      if (response.resultCode === "10000") {
        console.log("response---------:", response.data);
        this.allDiaData = response.data;
        var tempText = [];
        remarks.forEach((item) => tempText.push(item.message));
        this.allDiaData.forEach((item) => {
          console.log("item.origin:", item.origin);
          if (tempText.indexOf(item.content) !== -1) {
            item.flag = true;
          }
        });
      } else {
        this.$message.error(response.desc);
      }
    },
    selectTime(timeArr) {
      if (timeArr === null) {
        this.form.time = [];
        this.wrongMessageSearchDto.startTime = "";
        this.wrongMessageSearchDto.endTime = "";
      } else {
        this.wrongMessageSearchDto.startTime = this.util.timeStampToDate(
          timeArr[0],
          0
        );
        this.wrongMessageSearchDto.endTime = this.util.timeStampToDate(
          timeArr[1],
          0
        );
      }
      this.selectDate();
    },
    changeStatus(value) {
      if (value === "") {
        this.wrongMessageSearchDto.status = "";
      } else {
        this.wrongMessageSearchDto.status = Number(value);
      }
      this.selectDate();
    },
    async selectDate() {
      this.isLoading = true;
      this.currentPage = 1;
      var api = "/manager/wrongMessageDeal/selectByCondition";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.wrongMessageSearchDto,
      });
      console.log("response:", response);
      if (response.resultCode === "10000") {
        this.diaList = response.data;
        this.inforTotal = response.data.length;
        this.getItemInfo();
        this.isLoading = false;
      } else {
        this.$message.error(response.desc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}
.el-button {
  @include change_tip_size($tip_size_normal);
}
.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  @include change_title_size($title_size_normal);
  line-height: 1;
}
::v-deep  .el-form {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .header-item {
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .el-form-item__content {
    margin-left: 30px !important;
  }
  .reset-form {
    .el-input {
      width: 140px;
    }
  }
  .el-input-group__append {
    cursor: pointer;
  }
}
.headerForm {
  background: #fff;
}
.infoList {
  .infoList-item {
    border: 1px solid #999999;
    font-family: MicrosoftYaHei;
    margin-bottom: 40px;
    .infoList-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      @include change_size($font_size_normal);
      padding: 2px 20px;
      min-height: 32px;
      border-bottom: 1px solid #999999;
      div {
        margin-right: 60px;
        color: #333333;
      }
      .infoList-header-state {
        // margin-left: auto;
        margin-right: 0;

        i {
          cursor: pointer;
          font-size: 28px;
        }
        .el-icon-error {
          color: #de4f4f;
        }
        .el-icon-success {
          color: #07c160;
          margin-left: 30px;
        }
      }
    }
    .infoList-content {
      color: #999;
      padding: 10px 20px 0;

      @include change_size($font_size_normal);
      // @include change_tip_size($tip_size_normal);
      .infoList-content-footer {
        color: #999;
        margin: 6px 0;
      }
    }
  }
}
// // 弹窗字体：
.dialogFontSize {
  @include change_size($font_size_normal);
}
.dialogAllDia :deep() {
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
}

// 空数据样式
// .dataNull {
//   @include change_size($font_size_normal);
//   text-align: center;
//   line-height: 300px;
//   color: #909399;
// }
</style>
